import { IconAlertTriangle, IconLock } from "@tabler/icons-react";
import { Alert, Stack, Text } from "@/components/ui";

interface Props {
  enviadaAAutorizacion: boolean;
  fueRechazada: boolean;
  esSoloLectura: boolean;
  puedeAdjuntar: boolean;
  nivelDelRechazo: number | null;
  motivosRechazo: string[];
}

/**
 * Conjunto de banners contextuales que indican al usuario en qué
 * estado se encuentra la solicitud y qué puede o no hacer en esta
 * pantalla. Cada banner es excluyente del resto en la mayoría de
 * los casos, pero pueden coexistir en el render según la lógica.
 */
export function EstadoBanners({ enviadaAAutorizacion, fueRechazada, esSoloLectura, puedeAdjuntar, nivelDelRechazo, motivosRechazo }: Props) {
  return (
    <>
      {enviadaAAutorizacion && (
        <Alert variant="warning" icon={<IconLock size={16} stroke={1.7} />} title="Solicitud en autorización">
          Esta solicitud ya fue enviada al autorizador. No puedes modificar sus archivos hasta que el autorizador la rechace · solo entonces volverás a poder agregar o eliminar documentos.
        </Alert>
      )}

      {fueRechazada && (
        <Alert variant="warning" icon={<IconAlertTriangle size={16} stroke={1.7} />} title={`Solicitud devuelta para corrección · nivel ${nivelDelRechazo}`}>
          <Stack gap="xs">
            <Text size="sm">
              El autorizador rechazó la solicitud. Ajusta los archivos según los motivos y luego reenvíala · el flujo continuará desde el nivel {nivelDelRechazo} (las autorizaciones previas se
              conservan · decisión 37).
            </Text>
            {motivosRechazo.length > 0 && (
              <div>
                <Text size="xs" fw={600} className="mb-1 mt-2">
                  Motivos del rechazo:
                </Text>
                <ul className="list-disc space-y-0.5 pl-5 text-sm">
                  {motivosRechazo.map((m, i) => (
                    <li key={i}>{m}</li>
                  ))}
                </ul>
              </div>
            )}
          </Stack>
        </Alert>
      )}

      {!puedeAdjuntar && !enviadaAAutorizacion && !esSoloLectura && (
        <Alert variant="readonly" title="No puedes adjuntar en este estado">
          El estado actual no permite cargar documentos. Confirma primero el prorrateo.
        </Alert>
      )}

      {esSoloLectura && (
        <Alert variant="readonly" title="Vista de archivos">
          Modo consulta · puedes ver y descargar los archivos asociados a la solicitud. Solo el solicitante creador puede modificarlos.
        </Alert>
      )}
    </>
  );
}
